import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  initialFormData,
  MasterFormDataType,
  MasterTableDataType,
} from "./types";
import usePopup from "../../../hooks/usePopup";
import { useForm } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
import { saveMasterData } from "./services";
import {
  Paper,
  Typography,
  Button,
  CircularProgress,
  Divider,
} from "@mui/material";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getAllinsuranceType } from "../../../PatientCare/patientEncounter/services";
import useAuthentication from "../../../hooks/useAuthentication";
const pageTitle = "Insurance";
function AddOrEditInsurance() {
  const {user} = useAuthentication()
  const navigate = useNavigate();
  const { control, handleSubmit, reset } = useForm<MasterFormDataType>({
    defaultValues: initialFormData,
  });
  const {
    state: { data = null },
  } = useLocation() as { state: { data: MasterTableDataType } };
  const { showSnackbar } = usePopup();
  const handleGoBack = () => {
    navigate(-1);
  };

  const { data: insuranceTypes, isLoading: insuranceTypesLoading } = useQuery(
    ["AllinsuranceTypes"],
    getAllinsuranceType,
    { refetchOnWindowFocus: false }
  );

  const { mutate: save, isLoading } = useMutation(saveMasterData, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "success",
          duration: 3000,
        });
        handleGoBack();
      } else {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "warning",
          duration: 3000,
        });
      }
    },
    onError: (e: any) => {
      showSnackbar({
        message: e?.response?.data?.responseMessage || "Something went wrong !",
        open: true,
        variant: "error",
        duration: 3000,
      });
    },
  });
  const onSubmit = (value: MasterFormDataType) => {
    save({list:[
      {
        ...value,
        clinicId:user?.clinicId as number,
        insuranceTypeId:value.insuranceType?.id as number,
        insuranceCreatedByDate:"",
        insuranceCreatedById:Number(user?.userId),
        insuranceId:data?.insuranceId || 0
      },
    ]});
  };

  const handleReset = () => {
    reset(initialFormData);
  };

  useEffect(() => {
    if (data) {
      reset({
        insuranceCode:data.insuranceCode,
        insuranceName:data.insuranceName,
        insuranceStatus:data.insuranceStatus,
        license:data.license,
        insuranceType:{id:data.insuranceTypeId,name:data.insuranceTypeName}
      });
    }
  }, [data]);
  return (
    <div className="p-3">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Paper>
          <div className="flex justify-between items-center p-2">
            <div>
              <Typography variant="h6" className="p-3">
                {data ? "Update" : "Add"} {pageTitle}
              </Typography>
            </div>
            <div className="flex gap-2">
              <Button
                disabled={isLoading}
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={handleGoBack}
              >
                back
              </Button>
              {!Boolean(data) && (
                <Button
                  disabled={isLoading}
                  color="error"
                  type="reset"
                  onClick={handleReset}
                  startIcon={<CloseIcon />}
                >
                  reset
                </Button>
              )}
              <Button
                disabled={isLoading}
                type="submit"
                color="success"
                startIcon={
                  isLoading ? (
                    <CircularProgress size={20} color="success" />
                  ) : (
                    <SaveIcon />
                  )
                }
              >
                {data ? "update" : "save"}
              </Button>
            </div>
          </div>
          <Divider />
          <div className="p-3 grid grid-cols-4 gap-3">
            <CustomFormField
              control={control}
              name="insuranceCode"
              element="input"
              fieldProps={{ label: "Enter insurance code " }}
              rules={{ required: "Insurance code is required" }}
            />
            <CustomFormField
              control={control}
              name="insuranceName"
              element="input"
              fieldProps={{ label: "Enter insurance name " }}
              rules={{ required: "Insurance name is required" }}
            />
            <CustomFormField
              control={control}
              name="insuranceType"
              element="autocomplete"
              loading={insuranceTypesLoading}
              options={insuranceTypes?.response || []}
              fieldProps={{ label: "Choose Insurance type " }}
              rules={{ required: "Insurance type required" }}
              autocompleteProps={{
                getOptionLabel:option=>option.name
              }}
            />
            <div>
              <CustomFormField
                control={control}
                name="license"
                element="input"
                fieldProps={{ label: "Enter license id " }}
                rules={{ required: "License is required" }}
              />
            </div>
            <CustomFormField
              control={control}
              name="insuranceStatus"
              element="radio"
              radioProps={{ row: true }}
              radios={[
                { label: "Active", value: 1 },
                { label: "Inactive", value: 0 },
              ]}
              fieldProps={{ label: "Status " }}
              rules={{ required: "ICD version is required" }}
            />
          </div>
        </Paper>
      </form>
    </div>
  );
}

export default AddOrEditInsurance;
